import { Accordion, AccordionSummary, ListItemText, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Styled } from "./styles";

const Mandatory = () => {
    return (
        <Accordion disableGutters>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3-content"
                id="panel3-header"
            >
                What is mandatory information?
            </AccordionSummary>
            <Styled.AccordionDetails>
                <Typography variant="body2">
                    After 8 December 2023, all wine produced and labeled after that date must
                    include:
                </Typography>
                <Styled.OrderedList>
                    <Styled.ListItem>
                        <ListItemText primary="Allergen" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Energy" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="List of ingredients" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText
                            primary="
                            Nutrition information per 100ml"
                        />
                    </Styled.ListItem>
                </Styled.OrderedList>
                <Typography variant="body2">
                    Energy value and allergenic ingredients (1&2) must be on the physical label, but
                    the rest (3&4) of the information is allowed to be fully posted on the digital
                    label.
                </Typography>
                <Typography variant="body2">
                    Here is a list of what nutritional information should be provided per 100 ml
                    (energy in kJ/kCAL and other g):
                </Typography>
                <Styled.OrderedList>
                    <Styled.ListItem>
                        <ListItemText primary="Energy" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Fat of which: saturated fat" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Carbohydrates of which: sugars" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Protein" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText
                            primary="
                            Salt"
                        />
                    </Styled.ListItem>
                </Styled.OrderedList>
            </Styled.AccordionDetails>
        </Accordion>
    );
};

export default Mandatory;
